import { useEffect, useState, useRef } from 'react';
import { Route, Routes, Navigate, useLocation } from 'react-router-dom';
import Main from './pages/Main';
import Certificates from './pages/Certificates/iframe/Certificates';
import Snils from './pages/Snils';
import Admin from './pages/Admin';
import DispensaryObservation from './pages/DispensaryObservation/iframe/DispensaryObservation';
import Monitoring from './pages/Monitoring';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import keycloak from './keycloak';

const App = () => {
    const { pathname } = useLocation();

    const [loggedIn, setLoggedIn] = useState(false);
    const [userRoles, setUserRoles] = useState<string[]>([]);
    const [autorizedPerson, setAutorizedPerson] = useState(localStorage.getItem('fioAndOrganization'));
    const didInit = useRef(false);

    const getFioAndOrganization = (fioAndOrganization: string) => setAutorizedPerson(fioAndOrganization);

    useEffect(() => {
        if (didInit.current) return;
        didInit.current = true;

        let refreshIntervalRef: ReturnType<typeof setInterval> | undefined;

        keycloak
            .init({ onLoad: 'login-required' })
            // @ts-ignore
            .then((authenticated) => {
                localStorage.setItem(
                    'fioAndOrganization',
                    keycloak.tokenParsed.name + ' ' + keycloak.tokenParsed.patronymic,
                );
                setUserRoles(
                    keycloak.tokenParsed.realm_access.roles
                        .map((elem: string) => {
                            const cuttedElem = String(elem).substring(0, String(elem).indexOf('.'));
                            if (cuttedElem === 'monitoring') {
                                return 'mortality';
                            }
                            return cuttedElem;
                        })
                        .filter((elem: any) => elem),
                );
                setLoggedIn(authenticated);

                if (!authenticated) {
                    keycloak.login();
                    return; // если не аутентифицирован — таймер не нужен
                }

                // 🔄 Автоматическое обновление токена
                refreshIntervalRef = setInterval(() => {
                    keycloak
                        .updateToken(70)
                        .then((refreshed: any) => {
                            if (refreshed) {
                                console.log('Токен обновлён');
                            }
                        })
                        .catch((err: any) => {
                            console.error('Не удалось обновить токен', err);
                            keycloak.logout();
                        });
                }, 60000); // проверяем раз в минуту
            });

        return () => {
            if (refreshIntervalRef) clearInterval(refreshIntervalRef);
        };
    }, []);

    if (!loggedIn) {
        return <div>Загрузка...</div>;
    }

    const handleLogOff = () => setLoggedIn(false);

    return (
        <Box m={-1}>
            <Routes>
                <Route
                    path='/'
                    element={
                        loggedIn ? (
                            <Main
                                getFioAndOrganization={getFioAndOrganization}
                                handleLogOff={handleLogOff}
                                userRoles={userRoles}
                            />
                        ) : (
                            <Navigate to='/' />
                        )
                    }
                />
                <Route path='/certificates' element={<Certificates />} />
                <Route path='/largeFamilies' element={<Snils />} />
                <Route path='/admin' element={loggedIn ? <Admin /> : <Navigate to='/' />} />
                <Route path='/dispensary' element={<DispensaryObservation />} />
                <Route path='/monitoring' element={<Monitoring />} />
            </Routes>
            {autorizedPerson && (
                <Paper
                    sx={{
                        position: 'fixed',
                        bottom: 15,
                        left: 'auto',
                        right: 0,
                        height: '20px',
                        display: 'flex',
                        justifyContent: 'end',
                        paddingRight: 3,
                        paddingLeft: 1,
                        alignItems: 'center',
                        width: 'fit-content',
                    }}
                >
                    <Typography variant='caption'>{autorizedPerson}</Typography>
                </Paper>
            )}
        </Box>
    );
};
export default App;
